export default () => ({
  saltoShipRoomListLoading: false,
  saltoShipRoomList: null,
  saltoShipRoomListError: null,
});
